import * as types from '../../constants/action_types'

export const QUOTES_TABLE_METADATA_DEFAULT = {
  isLoading: false,
  sortBy: '',
  sortDirection: ''
}

export const initialState = {
  quotesBySupplier: {
    // For example
    /*
    333: [] // The supplier group map ID as key, and array of quotes as value.
    */
  },
  tableMetadata: {
    // For example:
    /*
    333: { // The supplier gropup map ID
      isLoading: true,
      sortBy: '',
      sortDirection: '',
    }
    */
  },
  saveQuote: {
    isLoading: false,
    completed: false
  },

  deleteQuote: {
    isLoading: false,
    completed: false
  },

  quote: {
    name: '',
    issued_on: '',
    price: '',
    currency: 'usd',
    quantity: '',
    weight: '',
    weight_unit: 'lbs',
    additional_fees: '',
    total_price: 0,
    lead_time: '',
    lead_time_interval: 'day',
    description: '',
    sample_cost: '',
    sample_shipping_cost: ''
  }
}

function supplierTrackerQuotesReducer(state = initialState, action) {
  switch (action.type) {
    case types.PENDING_GET_SUPPLIER_QUOTES: {
      const supplierGroupMapId = action.payload

      return {
        ...state,
        tableMetadata: {
          ...state.tableMetadata,
          [supplierGroupMapId]: {
            ...state.tableMetadata[supplierGroupMapId],
            isLoading: true
          }
        }
      }
    }
    case types.SET_SUPPLIER_QUOTES_DATA: {
      const { supplierGroupMapId, quotesBySupplier } = action.payload
      return {
        ...state,
        tableMetadata: {
          ...state.tableMetadata,
          [supplierGroupMapId]: {
            ...state.tableMetadata[supplierGroupMapId],
            isLoading: false
          }
        },
        quotesBySupplier: {
          ...state.quotesBySupplier,
          [supplierGroupMapId]: quotesBySupplier
        }
      }
    }
    case types.SORT_SUPPLIER_QUOTES: {
      const { supplierGroupMapId, sortDirection, sortBy } = action.payload

      return {
        ...state,
        tableMetadata: {
          ...state.tableMetadata,
          [supplierGroupMapId]: {
            ...state.tableMetadata[supplierGroupMapId],
            sortDirection,
            sortBy
          }
        }
      }
    }
    case types.PENDING_QUOTES_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: true,
          completed: false
        }
      }
    case types.COMPLETED_QUOTES_ACTION:
      return {
        ...state,
        [action.payload]: {
          isLoading: false,
          completed: true
        }
      }
    case types.RESET_QUOTES_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: false,
          completed: false
        }
      }
    case types.SET_SUPPLIER_QUOTE:
      return {
        ...state,
        quote: action.payload
      }
    default:
      return state
  }
}

export default supplierTrackerQuotesReducer
